var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "detail-summay-containter",
      attrs: { id: "analysis-recos-content" },
    },
    [
      _c("div", [
        _c("table", [
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("vendors")))]),
              _vm._v(" "),
              _c("th", { staticClass: "align-right" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("summary.submittedAmount")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "align-right" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t("summary.diffToLowestBid", [_vm.currencyCode])
                    ) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "align-right" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("summary.pctToLowestBid")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "align-right" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("summary.finalAmount")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.bids, function (bid) {
              return _c(
                "tr",
                {
                  key: bid.id,
                  class: [
                    { "highlight-recommended": _vm.highlightSelectedBid(bid) },
                    { lowestLine: _vm.highlightLowestBid(bid) },
                  ],
                },
                [
                  _c("td", { staticClass: "vendor-column" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.deep(bid, "company.name") || "") +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "open-sum align-right" }, [
                    _c("div", [_vm._v(_vm._s(_vm.renderedStatus(bid)))]),
                    _vm._v(" "),
                    bid.content
                      ? _c("span", [_vm._v(_vm._s(bid.content.declineReason))])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "align-right" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.showDiffToLowestAmount(bid)) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "align-right" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.showPctToLowestSum(bid)) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "final-amount align-right" }, [
                    _vm.showAdjustedInput(bid)
                      ? _c("span", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.currencyCode) +
                              "\n            "
                          ),
                        ])
                      : _vm._e(),
                    _vm.canEdit && _vm.isEditing && _vm.showAdjustedInput(bid)
                      ? _c("input", {
                          directives: [
                            {
                              name: "autowrap",
                              rawName: "v-autowrap",
                              value: { offset: 19 },
                              expression: "{offset: 19}",
                            },
                            {
                              name: "fusioninputcheck",
                              rawName: "v-fusioninputcheck",
                              value: {
                                type: "decimal",
                                pattern: function (val) {
                                  return (
                                    (Number((val || "").replace(/,/g, "")) ||
                                      0) > 0
                                  )
                                },
                                required:
                                  !!bid.content.service.totalFeeAdjustedText,
                              },
                              expression:
                                "{\n                type: 'decimal',\n                pattern: (val) => (Number((val || '').replace(/,/g, '')) || 0) > 0,\n                required: !!bid.content.service.totalFeeAdjustedText\n              }",
                            },
                          ],
                          staticClass: "input",
                          attrs: { type: "text" },
                          domProps: {
                            value: bid.content.service.totalFeeAdjustedText,
                          },
                          on: {
                            change: function (event) {
                              return _vm.markUpdate(bid, event.target.value)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isReadOnly && _vm.showAdjustedInput(bid)
                      ? _c("input", {
                          directives: [
                            {
                              name: "autowrap",
                              rawName: "v-autowrap",
                              value: { offset: 19 },
                              expression: "{offset: 19}",
                            },
                          ],
                          staticClass: "input",
                          attrs: { type: "text", disabled: _vm.isReadOnly },
                          domProps: {
                            value: _vm.CurrencyFormatter.format(
                              bid.content.service.totalFeeAdjustedText ||
                                bid.content.service.totalFee,
                              "USD"
                            ),
                          },
                          on: {
                            change: function (event) {
                              return _vm.markUpdate(bid, event.target.value)
                            },
                          },
                        })
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.canEdit || _vm.isAwarded || _vm.isReview
        ? _c(
            "Sticky",
            {
              staticClass: "sticky",
              attrs: { id: "analysis-reco-nav-bar-sticky" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "nav-bar clearfix",
                  attrs: { id: "analysis-reco-nav-bar" },
                },
                [
                  _vm.canEdit && _vm.isPicView
                    ? _c(
                        "div",
                        { staticClass: "clearfix nav-bar-item" },
                        [
                          _c("AwardTender", {
                            attrs: {
                              clickCheck: _vm.editableCheck,
                              isUnderEditing: !_vm.editable,
                              recommendedBidId: _vm.selectedBidId,
                              saveAnalysisRecoData: _vm.save,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canEdit && _vm.isEditing
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn--orange",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.save")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canEdit && _vm.isEditing
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn--darkblue",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.cancelEdit()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.cancel")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--darkblue",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.openAnalysis()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("summary.runAnalysis")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--darkblue",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.exportPDF()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.generatePDF")))]
                  ),
                  _vm._v(" "),
                  _vm.canEdit && !_vm.isEditing
                    ? _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "note",
                              rawName: "v-note",
                              value: {
                                text: _vm.noteText,
                                enable: !_vm.editable,
                              },
                              expression: "{text:noteText, enable:!editable}",
                            },
                          ],
                          staticClass: "btn btn--darkblue",
                          attrs: { type: "button", disabled: !_vm.editable },
                          on: {
                            click: function ($event) {
                              return _vm.enableEdit()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.edit")))]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "recommendation-container clearfix" },
        [
          _c(
            "Collapse",
            {
              attrs: {
                title: _vm.$t("summary.recommendation"),
                withBorder: false,
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c(
                  "div",
                  { attrs: { id: "accordion-recommendation-content" } },
                  [
                    _c("div", { attrs: { id: "detail-list" } }, [
                      _vm.showQuerySummary
                        ? _c(
                            "div",
                            { staticClass: "summary-detail-tender-query" },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("summary.tenderQuerySummary")
                                    ) +
                                    ":\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "description" }, [
                                _vm.isReadOnly
                                  ? _c("pre", { staticClass: "pre-text" }, [
                                      _vm._v(
                                        _vm._s(_vm.analysisReco.data.summary)
                                      ),
                                    ])
                                  : _c("textarea", {
                                      directives: [
                                        {
                                          name: "autosize",
                                          rawName: "v-autosize",
                                        },
                                        {
                                          name: "hkldinput",
                                          rawName: "v-hkldinput",
                                        },
                                      ],
                                      staticClass: "autosize",
                                      attrs: {
                                        id: "tender-query-summary-textarea",
                                        disabled: _vm.isReadOnly,
                                        placeholder:
                                          "Please input your remarks",
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.analysisReco.data.summary,
                                      },
                                      on: {
                                        change: function (event) {
                                          return _vm.updateAnalysisData(
                                            "summary",
                                            event.target.value
                                          )
                                        },
                                      },
                                    }),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { id: "summary-detail-tender-analysis" } },
                        [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("summary.tenderAnalysis")) +
                                ":\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _vm.isReadOnly
                              ? _c("pre", { staticClass: "pre-text" }, [
                                  _vm._v(
                                    _vm._s(_vm.analysisReco.data.analysis)
                                  ),
                                ])
                              : _c("textarea", {
                                  directives: [
                                    { name: "autosize", rawName: "v-autosize" },
                                    {
                                      name: "checkVisibility",
                                      rawName: "v-checkVisibility",
                                      value: { refresh: true },
                                      expression: "{refresh: true}",
                                    },
                                    {
                                      name: "hkldinput",
                                      rawName: "v-hkldinput",
                                    },
                                  ],
                                  staticClass: "autosize",
                                  attrs: {
                                    id: "tender-analysis-textarea",
                                    disabled: _vm.isReadOnly,
                                    placeholder: "Please input your remarks",
                                    type: "text",
                                  },
                                  domProps: {
                                    value: _vm.analysisReco.data.analysis,
                                  },
                                  on: {
                                    change: function (event) {
                                      return _vm.updateAnalysisData(
                                        "analysis",
                                        event.target.value
                                      )
                                    },
                                  },
                                }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("summary.recommendation")) +
                              ":\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm.isReadOnly
                            ? _c("pre", { staticClass: "pre-text" }, [
                                _vm._v(
                                  _vm._s(_vm.analysisReco.data.recommendation)
                                ),
                              ])
                            : _c("textarea", {
                                directives: [
                                  { name: "autosize", rawName: "v-autosize" },
                                  {
                                    name: "checkVisibility",
                                    rawName: "v-checkVisibility",
                                    value: { refresh: true },
                                    expression: "{refresh: true}",
                                  },
                                  { name: "hkldinput", rawName: "v-hkldinput" },
                                ],
                                staticClass: "autosize",
                                attrs: {
                                  id: "recommendation-textarea",
                                  disabled: _vm.isReadOnly,
                                  placeholder: "Please input your remarks",
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.analysisReco.data.recommendation,
                                },
                                on: {
                                  change: function (event) {
                                    return _vm.updateAnalysisData(
                                      "recommendation",
                                      event.target.value
                                    )
                                  },
                                },
                              }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row recommend-summary" }, [
                        _c(
                          "div",
                          { staticClass: "small-5 medium-5 large-5 columns" },
                          [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("summary.recommendedVendor")) +
                                  ":\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { attrs: { id: "recommend-vendor" } },
                              [
                                _c("HKLSelect", {
                                  attrs: {
                                    value:
                                      _vm.selectedBidVendorName || undefined,
                                    options: _vm.recommendedVendorHklOptions,
                                    disabled: _vm.isReadOnly,
                                    showSearch: false,
                                    placeholder: "",
                                  },
                                  on: { change: _vm.setRecommendedBidId },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "small-4 medium-4 large-4 columns" },
                          [
                            _c("label", { staticClass: "title align-right" }, [
                              _vm._v(
                                _vm._s(_vm.$t("summary.recommendedAmount")) +
                                  ": "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "label",
                              { staticClass: "currency-amount align-right" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.recommendedAmount) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "small-3 medium-3 large-3" }, [
                          _c("label", { staticClass: "title align-right" }, [
                            _vm._v(_vm._s(_vm.$t("summary.prAmount")) + ": "),
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticClass: "currency-amount align-right" },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.prAmount) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showAttachments,
                              expression: "showAttachments",
                            },
                          ],
                          staticClass: "align-left summary-attachment",
                          attrs: { id: "attachments" },
                        },
                        [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("attachments")) +
                                ":\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("FileUpload", {
                            staticClass: "fileUpload",
                            attrs: {
                              invalidDescriptionLength:
                                _vm.invalidDescriptionLength,
                              attachment: _vm.attachment,
                              resourceId: _vm.analysisReco.id,
                              readonly: _vm.isReadOnly,
                            },
                            on: {
                              "update:attachment": function ($event) {
                                _vm.attachment = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("AttachedPo", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isAwarded,
            expression: "isAwarded",
          },
        ],
        staticClass: "recommendation-container",
        attrs: {
          numberType: _vm.numberType,
          purchaseNumbers: _vm.numbers,
          poContracts: _vm.poContracts,
          resourceIdMap: _vm.poResourceIdMap,
          awardedDate: _vm.awardedDate,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }